export default {
  Produtos: [],
  EnbModal: { component: '', active: false, callback: '' },
  UploadImg: [],
  StatusProd: true,
  SelectedProdEdit: [{
    id: '',
    code: '',
    tipo: '',
    status: true,
    name: '',
    preco: 0,
    oferta: 0,
    img: [],
    descricao: '',
    dateOfertaStart: '',
    dateOfertaEnd: '',
    categoria: '[]',
    gerEstoque: false,
    statusEstoque: '',
    estoque: 0,
    pendencia: '',
    visibilidade: 1,
    visualizacao: 0,
    atributos: [],
    caracter: [
      { icon: 'LocationIcon', name: '' },
      { icon: 'RoomsIcon', name: '' },
      { icon: 'ToiletIcon', name: '' },
      { icon: 'ParkingIcon', name: '' },
      { icon: 'AreaIcon', name: '' }
    ],
    destaque: false
  }],
  SelectedCategEdit: {
    id: '',
    name: '',
    icon: ''
  },
  Categorias: [
    {
      active: false,
      name: ''
    }
  ],
  SelectedGiftEdit: {
    id: '',
    codigo: '',
    tipo: '',
    valor: 0,
    validade: '',
    gastoMin: 0,
    gastoMax: 0,
    produtos: [],
    produtoDel: [],
    categorias: [],
    categoriasDel: [],
    emails: '',
    limiteCupom: 0,
    limiteNprodutos: 0,
    limiteUser: 0,
    freteGratis: false,
    individual: false,
    itensVendaDel: false
  },
  Gifts: [],
  LinkSidebar: [
    {
      text: 'Painel',
      path: '/painel',
      icon: 'DashIcon'
    },
    {
      text: 'Produtos',
      path: '/painel/produtos',
      icon: 'ProdIcon'
    },
    {
      text: 'Clientes',
      path: '/painel/client',
      icon: 'ClientIcon'
    },
    {
      text: 'Pedidos',
      path: '/painel/pedidos',
      icon: 'ListIcon01'
    },
    {
      text: 'Usuários',
      path: '/painel/users',
      icon: 'UserIcon'
    },
    {
      text: 'Cupons',
      path: '/painel/gift',
      icon: 'GiftIcon'
    },
    {
      text: 'Pagamentos',
      path: '/painel/payments',
      icon: 'PayIcon'
    },
    {
      text: 'Frete',
      path: '/painel/frete',
      icon: 'DeliveryIcon'
    },
    {
      text: 'Preferências',
      path: '/painel/preference',
      icon: 'ConfigIcon'
    },
    {
      text: 'Marketing',
      path: '/painel/marketing',
      icon: 'MarketingIcon'
    },
    {
      text: 'Frente de loja',
      path: '/',
      icon: 'SiteIcon'
    },
    {
      text: 'Loja',
      path: '/loja',
      icon: 'StoreIcon01'
    }
  ],
  Template03: [
    'Produtos',
    'Usuários',
    'Marketing',
    'Preferências',
    'Loja',
    'Sair'
  ],
  IconSelected: '',
  GiftValidate: {
    codigo: { $invalid: false, has: { $invalid: false, $message: '' } },
    tipo: { $invalid: false },
    valor: { $invalid: false }
  },
  FilterProdPainel: {
    status: true,
    categoria: ''
  },
  Frete: {
    tipo: 'Taxa fixa',
    valor: '',
    valormin: '',
    gratisapartir: '',
    tokengoogleapi: '',
    cep: ''
  },
  FreteTabelaBairro: [],
  ProdutoStatus: {
    publicados: 0,
    arquivados: 0
  }
}
